import {takeEvery} from 'redux-saga/effects'
import {
  ADD_ASSESSMENT_GROUP,
  DELETE_ASSESSMENT_GROUP,
  GET_ASSESSMENT_GROUP,
  GET_ASSESSMENT_GROUPS,
  UPDATE_ASSESSMENT_GROUP,
} from 'setup/redux/Actions/AssessmentGroup/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_ASSESSMENT_GROUPS, fetchData)
  yield takeEvery(GET_ASSESSMENT_GROUP, fetchData)
  yield takeEvery(ADD_ASSESSMENT_GROUP, fetchData)
  yield takeEvery(UPDATE_ASSESSMENT_GROUP, fetchData)
  yield takeEvery(DELETE_ASSESSMENT_GROUP, fetchData)
}

export default dataSaga
